import { NavigateFunction } from 'react-router-dom';
import { Col, Row, Radio, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { ReactComponent as Home } from '../res/svg/filled-home.svg';
import { ReactComponent as UserGroupAdd } from '../res/svg/user-group-add.svg';
import { ReactComponent as Audit } from '../res/svg/audit.svg';
import { ReactComponent as Flag } from '../res/svg/flag.svg';
import { ReactComponent as UserIcon } from '../res/svg/user-filled.svg';
import { ReactComponent as LogOut } from '../res/svg/log-out.svg';
import { ReactComponent as Fund } from '../res/svg/black-fund.svg';
import { ReactComponent as BlackFlag } from '../res/svg/black-flag.svg';
import { ReactComponent as Capas } from '../res/svg/capas-black.svg';
import { ReactComponent as CapasEnabled } from '../res/svg/capas-white.svg';
import { ReactComponent as Excel } from '../res/svg/excel-file.svg';
import { ReactComponent as Reports } from '../res/svg/reports.svg';
import { setAccessArray } from './functions';
import User from '../models/User';

export const defaultColors = [
  {
    color: '#D9D9D9',
  },
  {
    color: '#19A576',
  },
  {
    color: '#36CFC9',
  },
  {
    color: '#BAE637',
  },
] as const;
declare global {
  type TaskResponse = {
    status: boolean;
    data?: any;
  };
}

export type NavSubsection = 'admin' | 'gestion' | 'catastro' | 'registros';

export function menuItems(showItemsMenu: boolean, user: User, subsection?: NavSubsection) {
  
  const accessArrayState = setAccessArray(
    {
      accesoAdministracion: user.accesoAdministracion,
      accesoCatastro: user.accesoCatastro,
      accesoGestion: user.accesoGestion,
      accesoRegistros: user.accesoRegistros,
    },
    true,
  );
  const userName = `${user.nombre}  ${user.apellido}`;
  const accessArray =
    accessArrayState.length !== 1
      ? accessArrayState
      : JSON.parse(localStorage.getItem('accessArray')!);
  if (!accessArray.includes('Cerrar Sesion')) {
    accessArray.push('Cerrar Sesion');
  }

  let subItems: any[] = [];

  switch (subsection){
    case 'admin':
      subItems = [
        { label: 'Inicio', key: 'admin', icon: <Home /> },
        { label: 'Tipos de Tareas', key: 'admin/tipos-tareas', icon: <Flag /> },
        { label: 'Roles', key: 'admin/roles', icon: <Audit /> },
        { label: 'Usuarios', key: 'admin/usuarios', icon: <UserGroupAdd /> },
      ];
      break;
    case 'gestion':
      subItems = [
        { label: 'Tareas', key: 'tareas', icon: <Flag /> },
        { label: 'Reportes', key: 'reportes', icon: <Reports /> },
      ];
      break;
    case 'catastro':
      subItems = [
        { label: 'Gestor de Capas', key: 'gestor-de-capas', icon: <CapasEnabled width={14}/> },
      ];
      break;
  }

  const userAndMenu = {
    label: user.nombre !== '' ? userName : localStorage.getItem('userName'),
    key: 'Submenu',
    icon: <UserIcon />,
    children: accessArray.map((item: any) => {
      let keyMain = '';
      let itemSubMenu = '';
      let iconSubMenu = <></>;
      switch (item) {
        case 'Cerrar Sesion':
          keyMain = 'logOut';
          itemSubMenu = 'Cerrar Sesion';
          iconSubMenu = <LogOut />;
          break;
        default:
          itemSubMenu = userAccess(item).label;
          keyMain = item;
          iconSubMenu = userAccess(item).icon;
          break;
      }
      return {
        label: itemSubMenu,
        key: keyMain,
        icon: iconSubMenu,
      };
    }),
  };
  return [...(showItemsMenu ? subItems : []), userAndMenu];
}
export function rolePermissions() {
  return (
    <Radio.Group name="permiso">
      <Row>
        <Col span={12}>
          <Radio value={0} style={{ lineHeight: '32px' }}>
            Coordinación{' '}
            <Tooltip placement="top" color={'#262626'} title="Coordinación">
              <QuestionCircleOutlined style={{ color: '#262626' }} />
            </Tooltip>
          </Radio>
        </Col>
        <Col span={12}>
          <Radio value={1} style={{ lineHeight: '32px' }}>
            Ejecución{' '}
            <Tooltip placement="top" color={'#262626'} title="Ejecución">
              <QuestionCircleOutlined style={{ color: '#262626' }} />
            </Tooltip>
          </Radio>
        </Col>
        <Col span={12}>
          <Radio value={2} style={{ lineHeight: '32px' }}>
            Auto-gestión{' '}
            <Tooltip placement="top" color={'#262626'} title="Auto-gestión">
              <QuestionCircleOutlined style={{ color: '#262626' }} />
            </Tooltip>
          </Radio>
        </Col>
        <Col span={12}>
          <Radio value={3} style={{ lineHeight: '32px' }}>
            Supervisión{' '}
            <Tooltip placement="top" color={'#262626'} title="Ejecución">
              <QuestionCircleOutlined style={{ color: '#262626' }} />
            </Tooltip>
          </Radio>
        </Col>
      </Row>
    </Radio.Group>
  );
}

export function adminItemsMenu(item: string, navigate: NavigateFunction) {
  switch (item) {
    case 'Administrar Tipos de Tareas': {
      return navigate('/admin/tipos-tareas');
    }
    case 'Administrar Roles': {
      return navigate('/admin/roles');
    }
    case 'Gestionar Usuarios': {
      return navigate('/admin/usuarios');
    }
    default: {
      return '/';
    }
  }
}

/**
 * @function userAccess
 * @description set the real access name to show in the ui
 * @return { string }
 */
function userAccess(access: string): any {
  switch (access) {
    case 'accesoAdministracion': {
      return { label: 'Administración', icon: <Fund /> };
    }
    case 'accesoCatastro': {
      return { label: 'Gestor de Capas', icon: <Capas /> };
    }
    case 'accesoGestion': {
      return { label: 'Gestor de Tareas', icon: <BlackFlag /> };
    }
    case 'accesoRegistros': {
      return { label: 'Gestor de Registros', icon: <Excel /> };
    }
    default: {
      return { label: '', icon: <></> };
    }
  }
}
